import './classComponentHook'
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import router from './router'
import '@/router/permission'
import store from './store'

// 雪碧图样式文件
import './styles/reset.less'
import './styles/element.less'
import './styles/sprite/sprite.less'
// 字体图标
import './assets/font/iconfont.css'
// 全局图形验证码弹框
import captcha from '@/plugins/captcha'
// i18n
import {i18n} from '@/i18n/index'

Vue.config.productionTip = false
//复制文本功能
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)
Vue.use(ElementUI)
Vue.use(captcha)

// 全局插件、组件等都需要在这里注册后才能使用
declare module 'vue/types/vue' {
  interface Vue {
    $captcha: Function
  }
}

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
  beforeCreate() {
    Vue.prototype.$bus = this //安装全局事件总线，$bus就是当前应用的vm
    // console.log(Vue.prototype.$bus);
  },
}).$mount('#app')
// 全局事件总线
export const eventBus = new Vue()